import React from "react";
import Callahan from "../images/logos-customer/callahan-capital-partners.png";
import KoiWaterfall from "../images/heros-and-graphics/koi-aerial-waterfall.webp";

function AboutStory() {
  return (
    <section>
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="pb-6">
          <div className="sm:flex">
            <figure className="flex flex-shrink-0 max-w-none sm:max-w-xs lg:max-w-none mb-8 sm:mb-0">
              <img
                className="flex-grow self-start rounded-xl shadow-xl max-w-[400px] w-full"
                src={KoiWaterfall}
                alt="Koi Waterfall"
              />
            </figure>
            <div className="sm:ml-0 lg:ml-8">
              {/* <h4 className="h4 mb-2">2021 - </h4> */}
              <p className="text-lg text-gray-600 mb-2">
                We have spent the last decade obsessing over a foundational
                question:{" "}
                <strong>
                  "what impact will technologies have as they scale?"
                </strong>{" "}
                This question is central to addressing the climate crisis and is
                why this team has logged countless hours collaborating,
                researching, and iterating on ways to most efficiently and
                reliably forecast the climate impact of solutions big and small.
              </p>
              <p className="text-lg text-gray-600 mb-2">
                What have we learned? Markets need radically transparent and
                auditable data, they need to trust forecasts that are all
                inherently guesses, and they need to do this much faster than
                they currently are. In order to more efficiently scale the most
                promising climate solutions, we need to move a <em>lot</em> of
                capital.
              </p>
              <p className="text-lg text-gray-600 mb-2">
                We are focused on building a foundational platform to unblock
                these massive flows of capital and ensure that it moves to teams
                and technologies with the best chance of making an impact. We
                have our work cut out for us but{" "}
                <strong>
                  we believe in the innovators and forward-thinking investors
                  who are tirelessly building the next generation of incredible
                  solutions.
                </strong>
              </p>
              <div className="flex my-8">
                <img
                  className="rounded-full self-start flex-shrink-0 mr-4 p-1 bg-rhoBlueDark-700 w-16 h-16 object-contain"
                  src={Callahan}
                  alt="Logo"
                />
                <div>
                  <blockquote className="text-gray-600 italic">
                    "Rho's expertise and capabilities are only rivaled by their
                    passion for the work and commitment to meaningful outcomes.
                    If you're seeking to maximize both your commercial
                    opportunities and impact on the world, I highly recommend
                    partnering with Rho."
                  </blockquote>
                  <div className="text-sm font-medium text-gray-600 mt-2">
                    <cite className="text-gray-900 not-italic">
                      Heather Holderman
                    </cite>{" "}
                    ·{" "}
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.callahancp.com/"
                    >
                      Callahan Capital Partners
                    </a>
                  </div>
                </div>
              </div>
              {/* <p className="text-lg text-gray-600 mb-8">
                Rho Impact's flagship data product,{" "}
                <a
                  className="rhoLinkLight"
                  href="https://koi.eco"
                  target="_blank"
                  rel="noreferrer"
                >
                  Koi
                </a>{" "}
                , builds upon our deep experience developing forecasting
                techniques and methodologies. Koi is the fastest, most reliable
                impact forecasting platform on the planet, built exclusively to
                help climate solutions win.
              </p> */}
              {/* <p className="text-lg text-gray-600 mb-8">
                Our involvement in what is now the{" "}
                <a
                  className="rhoLinkLight"
                  href="https://cranetool.org"
                  target="_blank"
                  rel="noreferrer"
                >
                  CRANE Tool
                </a>{" "}
                was the result of our partnership with{" "}
                <a
                  className="rhoLinkLight"
                  href="https://primecoalition.org"
                  target="_blank"
                  rel="noreferrer"
                >
                  Prime Coalition
                </a>
                , which has long been a foundational leader in advancing the
                field of catalytic capital. In 2017 Prime and NYSERDA published
                a seminal report entitled, "
                <a
                  className="rhoLinkLight"
                  href="https://www.primecoalition.org/library/climate-impact-assessment-for-early-stage-ventures"
                  target="_blank"
                  rel="noreferrer"
                >
                  Climate Impact Assessment for Early-Stage Ventures
                </a>
                ," in which they laid the foundation for everything that has
                been built today.
              </p> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutStory;
